/* @flow */
import idx from 'idx';
import * as React from 'react';
import userAgent from 'lib/currentUserAgent';

import './styles/Webcam.scss';

type Props = {
  width: number,
  height: number,
};

type State = {
  stream: *,
  streamURL: *,
  error: ?Error,
};

function options(width: number, height: number) {
  return {
    audio: false,
    video: {
      height: { max: height, idea: height },
      width: { max: width, ideal: width },
    },
  };
}

/* If you are a chrome user and want to use this component in dev
 * without https you need to open chrome with special flags:
 *
 * --unsafely-treat-insecure-origin-as-secure
 * --user-data-dir
 *
 * on osx:
 *
 * '/Applications/Google Chrome.app/Contents/MacOS/Google Chrome' --unsafely-treat-insecure-origin-as-secure="http://www.remind.localhost" --user-data-dir=/tmp/unsafe-google-profile
 *
 */
class Webcam extends React.Component<Props, State> {
  props: Props;

  state: State = {
    error: null,
    stream: null,
    streamURL: null,
  };

  static isSupported(): boolean {
    return (
      !userAgent.ie() &&
      !userAgent.safari() &&
      !!idx(window, _ => _.navigator.mediaDevices.getUserMedia)
    );
  }

  componentDidMount() {
    window.navigator.mediaDevices.getUserMedia(options(this.props.width, this.props.height)).then(
      stream => {
        const streamURL = window.URL.createObjectURL(stream);
        this.setState({ stream, streamURL });
      },
      error => {
        this.setState({ error });
      }
    );
  }

  componentWillUnmount() {
    if (this.state.stream) {
      this.state.stream.getVideoTracks()[0].stop();
    }
  }

  video: *;

  snap = (): ?string => {
    const video = this.video;

    if (!video) {
      return null;
    }

    const canvas = document.createElement('canvas');
    canvas.height = video.offsetHeight;
    canvas.width = video.offsetWidth;

    const context = canvas.getContext('2d');

    context.translate(canvas.width, 0);
    context.scale(-1, 1);
    context.drawImage(video, 0, 0);

    return canvas.toDataURL('image/png');
  };

  renderWebcam() {
    if (this.state.error) {
      return (
        <div className="Webcam-info">Oops, an error happened: {this.state.error.toString()}</div>
      );
    }

    if (!this.state.streamURL) {
      return <div className="Webcam-info">Please, allow remind.com to access your webcam.</div>;
    }

    if (this.state.streamURL) {
      return (
        <video
          autoPlay
          className="Webcam-video"
          width={this.props.width}
          src={this.state.streamURL}
          ref={video => (this.video = video)}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className="Webcam" style={{ height: this.props.height, width: this.props.width }}>
        {this.renderWebcam()}
      </div>
    );
  }
}

export default Webcam;
